import script from "./CustomerDataForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerDataForm.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerDataForm.vue?vue&type=style&index=0&id=2ee81188&scoped=true&lang=css"

import exportComponent from "../../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ee81188"]])

export default __exports__